/* eslint-disable no-param-reassign */
const redirectToMainLoginWebsite = () => {
  if (process.env.REACT_APP_LOGIN_URL) {
    window.location.href = process.env.REACT_APP_LOGIN_URL
  } else {
    throw new Error(
      `Impossible to redirect to '${process.env.REACT_APP_LOGIN_URL}'`
    )
  }
}

const fetchToken = async () => {
  if (typeof process.env.REACT_APP_CREDENTIALS_URL === 'undefined') {
    throw new Error(
      `Can't fetch credentials, REACT_APP_CREDENTIALS_URL not defined`
    )
  }
  const response = await fetch(process.env.REACT_APP_CREDENTIALS_URL, {
    mode: 'cors',
    credentials: 'include',
  })

  if (response.status === 401) {
    redirectToMainLoginWebsite()
  }
  const jwt = await response.text()
  sessionStorage.setItem('jwt', jwt)
  return jwt
}

const addTokenToInit = (jwt: string, init: RequestInit | undefined) => {
  if (typeof init === 'undefined') {
    init = {}
  }
  init.headers = new Headers(init.headers)
  init.headers.set('Authorization', `Bearer ${jwt}`)
  return init
}

export const fetchWithCheckAuthorization = async (
  url: string,
  init?: RequestInit,
  urlIsRelative = true
): Promise<Response> => {
  let absoluteUrl = url
  if (urlIsRelative) {
    if (typeof process.env.REACT_APP_BACKEND_URL === 'undefined') {
      throw new Error(`Can't make request, REACT_APP_BACKEND_URL not defined`)
    }
    absoluteUrl = process.env.REACT_APP_BACKEND_URL + url
  }

  let jwt = sessionStorage.getItem('jwt')
  if (jwt === null) {
    jwt = await fetchToken()
  }
  init = addTokenToInit(jwt, init)
  let response = await fetch(absoluteUrl, init)

  if (response.status === 401) {
    jwt = await fetchToken()
    init = addTokenToInit(jwt, init)
    response = await fetch(absoluteUrl, init)
  }

  return response
}

export default fetchWithCheckAuthorization
